const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const ANALYTICS_ENDPOINT = BACKEND_URL ? `${BACKEND_URL}/api/public/analytics/event` : null;
const VISITOR_KEY = "credita_visitor_id";
const SESSION_KEY = "credita_session_id";

const randomId = (prefix) => `${prefix}_${Math.random().toString(36).slice(2, 10)}${Date.now().toString(36)}`;

const ensureVisitorId = () => {
  try {
    let visitorId = localStorage.getItem(VISITOR_KEY);
    if (!visitorId) {
      visitorId = randomId("visitor");
      localStorage.setItem(VISITOR_KEY, visitorId);
    }
    return visitorId;
  } catch (error) {
    return null;
  }
};

const ensureSessionId = () => {
  try {
    let sessionId = sessionStorage.getItem(SESSION_KEY);
    if (!sessionId) {
      sessionId = randomId("session");
      sessionStorage.setItem(SESSION_KEY, sessionId);
    }
    return sessionId;
  } catch (error) {
    return null;
  }
};

const deviceType = () => {
  const ua = navigator.userAgent.toLowerCase();
  if (ua.includes("ipad") || ua.includes("tablet")) return "tablet";
  if (ua.includes("mobi") || ua.includes("android") || ua.includes("iphone")) return "mobile";
  return "desktop";
};

const browserName = () => {
  const ua = navigator.userAgent.toLowerCase();
  if (ua.includes("edg/")) return "Edge";
  if (ua.includes("opr/")) return "Opera";
  if (ua.includes("chrome/")) return "Chrome";
  if (ua.includes("firefox/")) return "Firefox";
  if (ua.includes("safari/") && !ua.includes("chrome/")) return "Safari";
  return "Desconhecido";
};

const osName = () => {
  const ua = navigator.userAgent.toLowerCase();
  if (ua.includes("windows")) return "Windows";
  if (ua.includes("iphone") || ua.includes("ipad") || ua.includes("ios")) return "iOS";
  if (ua.includes("android")) return "Android";
  if (ua.includes("mac os") || ua.includes("macintosh")) return "macOS";
  if (ua.includes("linux")) return "Linux";
  return "Desconhecido";
};

export const trackEvent = async (eventName, options = {}) => {
  if (!ANALYTICS_ENDPOINT || !eventName) return;

  const searchParams = new URLSearchParams(window.location.search);
  const payload = {
    event_name: eventName,
    path: options.path || window.location.pathname,
    visitor_id: ensureVisitorId(),
    session_id: ensureSessionId(),
    page_title: document.title,
    referrer: document.referrer || null,
    utm_source: options.utm_source || searchParams.get("utm_source"),
    utm_medium: options.utm_medium || searchParams.get("utm_medium"),
    utm_campaign: options.utm_campaign || searchParams.get("utm_campaign"),
    device_type: options.device_type || deviceType(),
    browser: options.browser || browserName(),
    os: options.os || osName(),
    metadata: options.metadata || {},
  };

  try {
    await fetch(ANALYTICS_ENDPOINT, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(payload),
      keepalive: true,
      credentials: "omit",
    });
  } catch (error) {
    // Analytics should never block the main UX.
  }
};

export const trackPageView = async (eventName, options = {}) => trackEvent(eventName, options);
